import React, { useState } from "react";
import { Reveal } from "./Motion";
import { Heart, Loader2 } from "lucide-react";
import { donate } from "../lib/api";
import { toast } from "sonner";

const TIERS = [5, 10, 20, 50, 100];

export const DonationSection = () => {
  const [amount, setAmount] = useState(20);
  const [loading, setLoading] = useState(false);

  const give = async () => {
    setLoading(true);
    try {
      const r = await donate(amount, window.location.origin);
      window.location.href = r.checkout_url;
    } catch {
      toast.error("Couldn't start the donation. Try again.");
      setLoading(false);
    }
  };

  return (
    <section className="max-w-[1100px] mx-auto px-4 sm:px-8 pb-24 sm:pb-32" data-testid="donation-section">
      <Reveal className="border border-line p-8 sm:p-14">
        <div className="flex items-center gap-3">
          <Heart size={18} className="text-cs-green" />
          <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-cs-green">Back the brand</p>
        </div>
        <h2 className="font-display font-extrabold text-3xl sm:text-5xl uppercase leading-[0.95] mt-5">
          Support<br />the brand
        </h2>
        <p className="text-graytx mt-5 max-w-lg leading-relaxed">
          Feeling the movement? Back Covertswag directly. Every dollar helps fund the next drop, keep quality high, and grow an independent brand from the ground up.
        </p>

        <div className="flex flex-wrap gap-3 mt-8" data-testid="donation-tiers">
          {TIERS.map((t) => (
            <button key={t} onClick={() => setAmount(t)} data-testid={`donate-tier-${t}`}
              className={`min-w-[72px] h-14 px-5 border font-display font-bold text-lg transition-colors duration-200 ${amount === t ? "bg-cs-green text-cream border-cs-green" : "border-line hover:border-cream"}`}>
              ${t}
            </button>
          ))}
        </div>

        <button onClick={give} disabled={loading} data-testid="donate-btn"
          className="mt-8 inline-flex items-center justify-center gap-2 bg-cream text-bg font-mono text-[12px] uppercase tracking-[0.2em] px-10 py-4 hover:bg-cs-green hover:text-cream disabled:opacity-60 transition-colors duration-200">
          {loading ? <><Loader2 size={15} className="animate-spin" /> Redirecting…</> : `Donate $${amount}`}
        </button>
        <p className="mt-3 font-mono text-[10px] uppercase tracking-widest text-graytx">Secure one-time donation via Stripe</p>
      </Reveal>
    </section>
  );
};
